import { postTime } from "../types";
import { formatTime } from "../../../utils/campaignSchedule";

// MB-1454: `<input type="time">` reports "" when cleared or half-typed, and
// parseInt("") is NaN. JSON.stringify cannot encode NaN, so it went over the
// wire as null and persisted as {hour:null, minute:null} — the shape that
// blanked the owner's campaign wizard on every mount. Returning null here
// means a cleared box simply does not change the saved time.
export const timeStringToPostTime = (timeStr: string): postTime | null => {
  const [hourStr, minuteStr] = timeStr.split(":");
  const hour = parseInt(hourStr, 10);
  const minute = parseInt(minuteStr, 10);
  const valid =
    Number.isInteger(hour) &&
    hour >= 0 &&
    hour <= 23 &&
    Number.isInteger(minute) &&
    minute >= 0 &&
    minute <= 59;
  return valid ? { hour, minute } : null;
};

// "" renders the picker blank rather than throwing. Guards both a malformed
// entry and an index past the end of postTimes.
export const postTimeToTimeString = (
  timeObj: postTime | null | undefined,
): string => formatTime(timeObj) ?? "";
